<template>
  <div class="container">
    <heard :title="'老年多模态多媒体语料库切分标注平台'" />
    <div class="content">
      <div class="title">
      </div>
      <!-- <el-tabs
        style="margin-top: 50px; position: relative; z-index: 1"
        v-model="activeName"
        @tab-click="handleClick"
      > -->
        <!-- <el-tab-pane label="mmse列表" name="first"> -->
          <userList :current="'mmse'" />
        <!-- </el-tab-pane> -->
        <!-- <el-tab-pane label="moca列表" name="second">
          <userList :current="'moca'" v-if="activeName == 'second'" />
        </el-tab-pane> -->
      <!-- </el-tabs> -->
    </div>
    <foot />
  </div>
</template>

<script>
import user from "../components/portrait.vue";
import heard from "../components/heard.vue";
import foot from "../components/footer.vue";
import userList from "../components/userList.vue";
import { mapState } from "vuex";

export default {
  name: "VueMmse",
  data() {
    return {
      activeName: "first",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    if (this.$route.query.isMoca) {
      this.activeName = "second";
    }
  },
  methods: {
    handleClick(tab) {
      this.activeName = tab.index == 0 ? "first" : "second";
    },
  },
  components: {
    heard,
    foot,
    user,
    userList,
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  .content {
    height: calc(100% - 138px);
    box-sizing: border-box;
    overflow-y: auto;
    padding: 0 60px;
    .title {
      margin: 30px 0;
      color: black;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
      position: relative;
      .userPotrait {
        position: absolute;
        right: 0px;
        top: 0;
        z-index: 5;
      }
    }
  }
}
</style>
